var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help-first-page"},[_c('div',{staticClass:"help-text-content",attrs:{"data-langname":"lb_help_2"}})])}]

export { render, staticRenderFns }